export default {
    ADD_DOCUMENT: "Создать документ"
};
